export default __webpack_public_path__ + "static/media/demo2.d0c75360.png";